export const formatPhoneForDisplay = (num: string | undefined | null) => {
  if (num === undefined || num === null) {
    return '';
  }
  const numArr = [];
  numArr.push(num.substring(0, 3));
  numArr.push(num.substring(3, 6));
  numArr.push(num.substring(6));
  return `${numArr[0]}-${numArr[1]}-${numArr[2]}`;
};
